export default __webpack_public_path__ + "static/media/multitenant.7f78e0ac.svg";